module.exports = __webpack_public_path__ + "img/bg.7078e304.jpg";